import { render, staticRenderFns } from "./SliderOnboardingExpress.vue?vue&type=template&id=05174c87&"
import script from "./SliderOnboardingExpress.vue?vue&type=script&lang=js&"
export * from "./SliderOnboardingExpress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports